import {distributionWebsocketCommands} from '../../constants/distributionWebsocketCommands';
import get from 'get-value';

export const adminBusinessUnitList = (state = {
    correlationId: null,
    isLoading: false,
    isTableLoading: false,
    isBusinessUnitListLoading: false,
    listData: [],
    shortListData: [],
    pages: 0,
}, action) => {
    switch (action.type) {
        case distributionWebsocketCommands.DISTRIBUTION_BUSINESS_UNITS_LIST_FETCH_PENDING: {
            return Object.assign({}, state, { isTableLoading: true, listData: [] });
        }
        case distributionWebsocketCommands.DISTRIBUTION_BUSINESS_UNITS_LIST_SEND: {
            const { correlationId } = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            } else {
                return Object.assign({}, state, {
                    isTableLoading: false,
                    listData: get(action, 'payload.result.data', { default: [] }),
                    pages: get(action, 'payload.result.pages', { default: 0 }),
                    correlationId
                });
            }
        }
        case distributionWebsocketCommands.DISTRIBUTION_BUSINESS_UNITS_LIST_SEND_ERROR: {
            const { correlationId } = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            } else {
                return Object.assign({}, state, { isTableLoading: false, correlationId });
            }
        }
        default:
            return state;
    }
};
